// Section for import npm components ------------------------------------------------------------------------------------
import React from 'react';

// MUI components
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Rating from '@mui/material/Rating';
import SentimentSatisfiedRoundedIcon from '@mui/icons-material/SentimentSatisfiedRounded';
// Section for import custom components --------------------------------------------------------------------------------

// import CommonUtility from '@utils/Common';

// Section for type definition -----------------------------------------------------------------------------------------
type ReviewItemProps = {
  reviewId: number;
  contents: string;
  reviewDate: string;
  reviewer: {
    name: string;
    type: string;
  };
  score: number;
  category: string;
};

// import CommonUtilityClass from '@/types/CommonUtilityClass';

// const commonUtil: CommonUtilityClass = CommonUtility;

const CustomRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#808080',
  },
  '& .MuiRating-iconHover': {
    color: '#808080',
  },

  '& .MuiRating-icon': {
    fontSize: '12px', // 星の大きさを指定
    lineHeight: '16px', // lineHeightを指定
  },
  marginTop: '2px',
});

export default function ReviewItem(props: ReviewItemProps) {
  const { reviewId, contents, reviewDate, reviewer, score, category } = props;

  // reviewDateを日本の日付形式に変換
  const formattedReviewDate: string = new Date(reviewDate).toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const formattedScore: string | false = score ? score.toFixed(1) : false;

  const isCategoryTotal = category === 'total';
  const isCategoryHope = category === 'hope';
  const isReview = !isCategoryTotal && !isCategoryHope;
  const hrefId = category + reviewId;
  return (
    <Box className="p-4 max-md:p-0 max-md:py-4 max-md:px-3 border border-border rounded">
      <Box id={hrefId} className="flex gap-x-2">
        <Typography className="text-rf-black text-sm font-bold">
          <SentimentSatisfiedRoundedIcon
            sx={{
              color: '#FFA0A0',
              width: '18px',
              height: '18px !important',
              lineHeight: '20px',
              marginRight: '2px',
            }}
          />
          {reviewer.name}
        </Typography>
        <Typography className="px-2 text-sm bg-gray-01"> {reviewer.type}</Typography>
      </Box>
      <Typography className="mt-3 text-rf-black text-sm">{contents}</Typography>
      <Box className="flex justify-between mt-2">
        <Typography className="text-gray-04 text-xs">投稿日：{formattedReviewDate}</Typography>
        {isReview && (
          <Box className="flex gap-x-1">
            <CustomRating name="half-rating-read" defaultValue={score} precision={0.1} readOnly />
            <Typography className="text-gray-04 text-xs">{formattedScore}</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
